var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('c-feature-icon',{staticClass:"mr-1",attrs:{"checked":"","icon":_vm.icon}}),_c('span',{domProps:{"textContent":_vm._s(_vm.caption)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }